/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  $(document).on('ajax.replace', () => {
    setTimeout(() => {
      rebindToggle()
    }, 1)
  })
  rebindToggle()
  // checkElementHeight('important-info', 64)
}

function rebindToggle() {
  const $toggle = $('[data-toggle]')

  $toggle.on('click', function(event) {
    const $this = $(this)
    const ids = $this.data('toggle').split(',')
    const $targets = $(ids.map(id => '[data-toggle-target="' + id + '"]').join(','))

    /**
     * Only remove open if close targets are open
     * Used on the body open class when toggling menu and search.
     * e.g. if search is open then remove open from body so it can be toggled again
     * if search is closed don't remove the class and let it get toggled normally.
     */
    if ($this.data('toggle-close')) {
      const closeIds = $this.data('toggle-close').split(',')
      const $closeTargets = $(closeIds.map(id => '[data-toggle-target="' + id + '"]').join(','))
      if ($this.data('toggle-close-optional')) {
        if ($closeTargets.hasClass('open')) {
          const optionalIds = $this.data('toggle-close-optional').split(',')
          const $optionalTargets = $(optionalIds.map(id => '[data-toggle-target="' + id + '"]').join(','))
          $optionalTargets.removeClass('open')
        }
      }
      $closeTargets.removeClass('open')
    }

    event.preventDefault()

    $this.toggleClass('open')
    $targets.toggleClass('open')

    if ($this.data('toggleBlur') === '') {
      $this.trigger('blur')
    }

    if ($this.data('toggle-focus') && $('#' + $this.data('toggle-focus')).is(':visible')) {
      $('#' + $this.data('toggle-focus')).trigger('focus')
    }
  })
}

// function checkElementHeight(id, maxHeight) {
//   const $element = $('[data-toggle-target="' + id + '"]')

//   if ($element.height() < maxHeight) {
//     hideButton(id)
//   }
// }

// function hideButton(id) {
//   const $button = $('[data-toggle="' + id + '"]')

//   $button.css('display', 'none')
// }
